(() => {
  if (window.__obpHomeEmotionReady) return;
  window.__obpHomeEmotionReady = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-obp-home-video-play]');
    if (!button) return;

    const frame = button.closest('[data-obp-home-video]');
    const videoId = frame?.dataset.videoId;
    if (!frame || !videoId) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1`;
    iframe.title = button.dataset.videoTitle || 'One Button Phone im Alltag';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    frame.replaceChildren(iframe);
  });
})();
